import React from 'react';
import { Router, Route } from 'dva/router';
import { LocaleProvider } from 'antd';
import ja_JP from 'antd/lib/locale-provider/ja_JP';
import SchoolBlogPage from '../components/SchoolBlogPage';

function RouterConfig(props) {
  return (
    <LocaleProvider locale={ja_JP}>
      <Router history={props.history}>
        {/* <Route path="/" component={SchoolBlogPage} /> */}
        <Route path="/school" render={() => <SchoolBlogPage appKey={props.app.appkey} />} />
      </Router>
    </LocaleProvider>
  );
}

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/school_blog/config/router.js